import React from 'react';
import { TabItem, Tabs } from '@navi/web-ui/lib/components';
import { TabItemKey } from '@navi/web-ui/lib/components/Tabs/types';
import styles from '@cp/pages/CsaPerformanceDashboard/index.module.scss';
import { noop } from '@utils/common';
import AgencyCapping from '@cp/pages/AgencyCapping';
import { AGENCY_UTILS_TAB_KEY, AGENCY_UTILS_TAB_NAME } from '@cp/pages/AgencyUtils/contants';
import AgencyPincodeMapping from '@cp/pages/AgencyPincodeMapping';
import { interpolatePathParams } from '@cp/utils/interpolate';
import APP_ROUTES from '@cp/src/layout/Routes';
import { useNavigate, useParams } from 'react-router-dom';
import { LocalStorage } from '@cp/utils/StorageUtils';
import cx from 'classnames';
import CsaPerformanceDashboardHeader from '@cp/pages/CsaPerformanceDashboard/components/Header';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { AGENCY_CAPPING_CLICKSTREAM } from '@cp/src/service/clickStream.constant';
let AGENCY_UTILS_TABS = [
  {
    key: AGENCY_UTILS_TAB_KEY.PINCODE_MAPPING,
    value: AGENCY_UTILS_TAB_NAME.PINCODE_MAPPING,
    component: <AgencyPincodeMapping />,
    relativePath: '/agency-utils/agency_pincode_mapping'
  },
  {
    key: AGENCY_UTILS_TAB_KEY.AGENCY_CAPPING,
    value: AGENCY_UTILS_TAB_NAME.AGENCY_CAPPING,
    component: <AgencyCapping />,
    relativePath: '/agency-utils/agency_capping'
  }
];
function AgencyUtils() {
  const { tabId = '' } = useParams();
  const navigate = useNavigate();
  const isAgencyCappingEnabled = useSelector(
    (store: RootState) => store?.common?.featureFlags?.agencyCappingEnabled
  );
  const isPincodeMappingEnabled = useSelector(
    (store: RootState) => store?.common?.featureFlags?.agencyServiceability
  );
  if (!isAgencyCappingEnabled) {
    AGENCY_UTILS_TABS = AGENCY_UTILS_TABS.filter(
      tab => tab.key !== AGENCY_UTILS_TAB_KEY.AGENCY_CAPPING
    );
  }

  if (!isPincodeMappingEnabled) {
    AGENCY_UTILS_TABS = AGENCY_UTILS_TABS.filter(
      tab => tab.key !== AGENCY_UTILS_TAB_KEY.PINCODE_MAPPING
    );
  }

  const paramsMap: Record<string, string> = LocalStorage.getItem('paramsMap') || {};
  const handleTabChange = (updateTabId: TabItemKey) => {
    if (tabId !== updateTabId) {
      if (updateTabId === AGENCY_UTILS_TAB_KEY.AGENCY_CAPPING)
        addClickstreamEvent(AGENCY_CAPPING_CLICKSTREAM.LH_CLICK_AGENCY_CAPPING_TAB);
      else addClickstreamEvent(AGENCY_CAPPING_CLICKSTREAM.LH_CLICK_PINCODE_MAPPING_TAB);
      const updatedUrl = interpolatePathParams('/agency-utils/:tabId', {
        tabId: String(updateTabId)
      });
      const currentParams = paramsMap[updatedUrl] || '';
      navigate(updatedUrl + currentParams);
    }
  };
  return (
    <>
      <div className="w-full relative">
        <Tabs
          selectedTabKey={tabId}
          tabsClassName={cx(styles.tabContainerClass, '!top-0', 'pt-8 mb-8')}
          onTabChange={handleTabChange}
        >
          {AGENCY_UTILS_TABS.map(tab => {
            return (
              <TabItem key={tab.key} label={tab.value} tabPanelClass="w-[120px] justify-center">
                {tab.component}
              </TabItem>
            );
          })}
        </Tabs>
      </div>
    </>
  );
}

export default AgencyUtils;
